<template>
    <div class="main">
        <c-panel title="ALUNOS POR GRUPO" titleIcon="fas fa-list-ol">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Relação dos alunos de cada grupo, com o modo em que o grupo opera na data escolhida."
                description="Quando não há faixa de escala na data, o modo exibido é o padrão do grupo — e isso fica indicado."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Configuração" class="u-mb-0">
                            <el-select v-model="filtro.configuracao_grupo_aluno_id" clearable filterable
                                style="width: 100%;" @change="carregar">
                                <el-option v-for="c in configuracoes" :key="c.id" :value="c.id" :label="c.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="filtro.instituicao_id" clearable filterable style="width: 100%;" @change="carregar">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Data de referência" class="u-mb-0">
                            <el-date-picker v-model="filtro.data" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width: 100%;" @change="carregar"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4" class="u-text-right u-mt-25">
                        <el-button icon="el-icon-printer" size="small" :disabled="!dados" @click="imprimir">IMPRIMIR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="dados">
                <el-alert type="success" :closable="false" class="u-mb-15"
                    :title="dados.total_alunos + ' aluno(s) em ' + dados.grupos.length + ' grupo(s)'"></el-alert>

                <div v-for="g in dados.grupos" :key="g.grupo_id" class="grupo-bloco">
                    <div class="grupo-cab">
                        {{ g.instituicao }} — {{ g.turma }} · <strong>{{ g.grupo }}</strong>
                        <span class="modo">
                            <el-tag size="mini" :type="corModo(g.modo_na_data)">{{ g.modo_na_data }}</el-tag>
                            <small v-if="g.origem_modo === 'modo_padrao'" class="u-text-muted"> (modo padrão — sem escala nesta data)</small>
                        </span>
                    </div>
                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 60px;">#</th>
                                    <th>Aluno</th>
                                    <th style="width: 160px;">Matrícula</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(a, i) in g.alunos" :key="a.matricula_id">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ a.nome }}</td>
                                    <td>{{ a.num_matricula || '—' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <small class="u-text-muted">
                        Configuração: {{ g.configuracao }} · rodízio {{ g.regime_rodizio }} · {{ g.qtd_alunos }} aluno(s)
                    </small>
                </div>

                <el-alert v-if="dados.grupos.length === 0" type="info" :closable="false"
                    title="Nenhum grupo encontrado para os filtros informados."></el-alert>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO H — item 126: relatório de alunos por grupo. */
export default {
    data: () => ({
        filtro: { configuracao_grupo_aluno_id: null, instituicao_id: null, data: '' },
        configuracoes: [], instituicoes: [], dados: null
    }),
    mounted () {
        this.filtro.data = new Date().toISOString().substring(0, 10)

        const periodo = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : ''

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/configuracao-grupo-aluno/getAll/${periodo}`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.configuracoes = Array.isArray(r.data) ? r.data : [] })
         .catch(e => this.$store.commit('throwException', e))

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})

        this.carregar()
    },
    methods: {
        corModo (m) {
            return { presencial: 'success', remoto: 'info', hibrido: 'warning' }[m] || 'info'
        },
        carregar () {
            this.dados = null
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/grupo-aluno/relatorio`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.dados = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },
        imprimir () {
            window.eventBus.$emit('print', {
                url: '/api/grupo-aluno/imprimirRelatorio',
                param: this.filtro
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.grupo-bloco { margin-bottom: 22px; }
.grupo-cab { background: #f5f7fa; border: 1px solid #e4e7ed; padding: 8px 10px; margin-bottom: 6px; }
.grupo-cab .modo { float: right; }
</style>
